import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    Row,
} from "reactstrap";
import Select from "react-select";
import { MetaTags } from "react-meta-tags";
import {
    Breadcrumb_inputName,
    commonPageField,
    commonPageFieldSuccess,
    editGroupIDSuccess,
    updateGroupIDSuccess
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    initialFiledFunc,
    resetFunction
} from "../../../components/Common/validationFunction";

import { SaveButton } from "../../../components/Common/CommonButton";
import {

    CommonConsole,
    IsCBMManagment,
    IsCSSManagment,
    isFoodERPDotIn,
    isRACompany,
    IsSweetAndSnacksCompany,
    loginCompanyID,
    loginPartyName,
    loginSelectedPartyID,
    loginUserID,
    metaTagLabel
} from "../../../components/Common/CommonFunction";
import { mode, url, pageId } from "../../../routes/index";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { saveMsgUseEffect, userAccessUseEffect } from "../../../components/Common/CommonUseEffect";
import { getpartysetting_API, savePartySetting, savePartySettingMaster_Success } from "../../../store/Administrator/PartySetting/action";
import Slidewithcaption from "../../../components/Common/CommonImageComponent";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { showToastAlert } from "../../../helpers/axios_Config";


const InvoiceConfiguration = (props) => {

    const history = useHistory()
    const dispatch = useDispatch();
    const IsSweetAndSnacks = IsSweetAndSnacksCompany()
    const fileds = {
        // PaymentQR: "",
        HSNCodeDigit: "",
        TCSAmountRound: "",
        InvoiceAmountRound: "",
        Invoicea4: "",
        ShowBatch: "",
        AddressInInvoice: "",
        AutoEInvoice: "",
        EInvoiceApplicable: "",
        CreditDebitAmountRound: "",
        PaymentQr: "",
        ReturnA4Print: "",
        CRDRNoteA4Print: "",
        EWayBillApplicable: "",
        OrderA4Print: "",
        AutoInvoiceSendToSap: "",
        AutoEwayBill: "",
        Showmixitem: "",
        ShowChallanOnSalesOrder: "",
        ShowBatchNoOnGRNPrint: "",
        DatauploadtoTally: "",
        ShowBatchNoOnChallanPrint: "",
        ORDER_SPLIT_GST_NONGST: ""
        // IsTCSPercentageforNonValidatedPANCustomer: "",
        // IsTCSPercentageforValidatedPANCustomer: ""
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [modalCss, setModalCss] = useState(false);
    const [userPageAccessState, setUserAccState] = useState('');
    const [hsnDropOption] = useState([{ value: "0", label: "0 Digits" }, { value: "1", label: "4 Digits" }, { value: "2", label: "6 Digits" }, { value: "3", label: "8 Digits" }])
    const [editCreatedBy, seteditCreatedBy] = useState("");
    const [imageTable, setImageTable] = useState([]);  // Selected Image Array
    const [modal_backdrop, setmodal_backdrop] = useState(false);   // Image Model open Or not



    //Access redux store Data /  'save_ModuleSuccess' action data
    const {
        PartySettingdata,
        updateMsg,
        pageField,
        postMsg,
        saveBtnloading,
        commonPartyDropSelect,
        userAccess } = useSelector((state) => ({
            saveBtnloading: state.PartySettingReducer.saveBtnloading,
            postMsg: state.PartySettingReducer.postMsg,
            PartySettingdata: state.PartySettingReducer.PartySettingdata,
            updateMsg: state.GroupReducer.updateMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField,
            commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect
        }));

    const { values } = state
    const { isError } = state;
    const { fieldLabel } = state;

    const { Data = {}, SystemSetting = {} } = PartySettingdata;


    const location = { ...history.location }
    const hasShowloction = location.hasOwnProperty(mode.editValue)
    const hasShowModal = props.hasOwnProperty(mode.editValue)

    useEffect(() => {
        const page_Id = pageId.INVOICE_CONFIGURATION
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))


    }, []);

    useEffect(() => {

        if (commonPartyDropSelect) {
            dispatch(getpartysetting_API(loginSelectedPartyID(), loginCompanyID()))
        }
    }, [commonPartyDropSelect]);


    // userAccess useEffect
    useEffect(() => userAccessUseEffect({
        props,
        userAccess,
        dispatch,
        setUserAccState,
    }), [userAccess]);


    useEffect(() => {

        if ((hasShowloction || hasShowModal)) {

            let hasEditVal = null
            if (hasShowloction) {
                setPageMode(location.pageMode)
                hasEditVal = location.editValue
            }
            else if (hasShowModal) {
                hasEditVal = props.editValue
                setPageMode(props.pageMode)
                setModalCss(true)
            }

            if (hasEditVal) {

                const { id, Name, GroupType, GroupTypeName } = hasEditVal
                const { values, fieldLabel, hasValid, required, isError } = { ...state }

                values.Name = Name;
                values.id = id
                values.GroupTypeName = { label: GroupTypeName, value: GroupType };

                hasValid.Name.valid = true;
                hasValid.GroupTypeName.valid = true;

                setState({ values, fieldLabel, hasValid, required, isError })
                dispatch(Breadcrumb_inputName(hasEditVal.Name))
                seteditCreatedBy(hasEditVal.CreatedBy)
            }
            dispatch(editGroupIDSuccess({ Status: false }))
        }
    }, [])



    useEffect(() => saveMsgUseEffect({
        postMsg, pageMode,
        history, dispatch,
        postSuccss: savePartySettingMaster_Success,
        resetFunc: { fileds, state, setState },
        listPath: url.INVOICE_CONFIGURATION,
    }), [postMsg])

    useEffect(() => {
        if (postMsg?.Status === true) {
            dispatch(getpartysetting_API(
                loginSelectedPartyID(),
                loginCompanyID()
            ));
        }
    }, [postMsg]);
    useEffect(() => {
        if (updateMsg.Status === true && updateMsg.StatusCode === 200 && !modalCss) {
            setState(() => resetFunction(fileds, state))// Clear form values
            history.push({
                pathname: url.GROUP_lIST,
            })
        } else if (updateMsg.Status === true && !modalCss) {
            dispatch(updateGroupIDSuccess({ Status: false }));
            customAlert({
                Type: 3,
                Message: JSON.stringify(updateMsg.Message),
            })
        }
    }, [updateMsg, modalCss]);

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    useEffect(() => {
        if (imageTable.length > 0) {
            setmodal_backdrop(true)
        }
    }, [imageTable])


    useEffect(() => {

        if (Object.keys(Data).length > 1) {

            if (Data.HSNCodeDigit.Value === "0") {
                Data.HSNCodeDigit.Value = { value: "0", label: "0 Digits" }
            } else if (Data.HSNCodeDigit.Value === "1") {
                Data.HSNCodeDigit.Value = { value: "1", label: "4 Digits" }
            } else if (Data.HSNCodeDigit.Value === "2") {
                Data.HSNCodeDigit.Value = { value: "2", label: "6 Digits" }
            } else if (Data.HSNCodeDigit.Value === "3") {
                Data.HSNCodeDigit.Value = { value: "3", label: "8 Digits" }
            } else {
                Data.HSNCodeDigit.Value = { value: "3", label: "8 Digits" }
            }

            setState((i) => {

                const a = { ...i }
                a.values.Invoicea4 = Data.A4Print;
                a.values.AddressInInvoice = Data.AddressOnInvoice;
                a.values.HSNCodeDigit = Data.HSNCodeDigit;
                a.values.InvoiceAmountRound = Data.InvoiceAmountRoundConfiguration;
                a.values.ShowBatch = Data.ShowBatchNoOnInvoicePrint;
                a.values.ShowBatchNoOnGRNPrint = Data.ShowBatchNoOnGRNPrint;
                a.values.TCSAmountRound = Data.TCSAmountRoundConfiguration;
                a.values.EInvoiceApplicable = Data.EInvoiceApplicable;
                a.values.AutoEInvoice = Data.AutoEInvoice;
                a.values.CreditDebitAmountRound = Data.CreditDebitAmountRoundConfiguration;
                a.values.PaymentQr = Data.PaymentQRCodeimageonInvoice;
                a.values.PaymentQr["Image"] = SystemSetting.Qr_Image;
                a.values.ReturnA4Print = Data.ReturnA4Print;
                a.values.CRDRNoteA4Print = Data.CRDRNoteA4Print;
                a.values.EWayBillApplicable = Data.EWayBillApplicable;
                a.values.OrderA4Print = Data.OrderA4Print;
                a.values.AutoInvoiceSendToSap = Data.AutoInvoiceSendToSap;
                a.values.AutoEwayBill = Data.AutoEwayBill;
                a.values.Showmixitem = Data.Showmixitem;
                a.values.ShowChallanOnSalesOrder = Data.ShowChallanOnSalesOrder;
                a.values.DatauploadtoTally = Data.DatauploadtoTally;
                a.values.ShowBatchNoOnChallanPrint = Data.ShowBatchNoOnChallanPrint;
                a.values.ORDER_SPLIT_GST_NONGST = Data.ORDER_SPLIT_GST_NONGST;

                return a
            })
        }

    }, [Data,])


    const onChangeSelecthandler = (e) => {

        setState((i) => {
            const a = { ...i }
            a.values.HSNCodeDigit.Value = e;
            return a
        })

    }


    const onchangeHandler = async (event, key, type) => {

        const file = Array.from(event.target.files)
        setState((i) => {
            const a = { ...i }
            a.values.PaymentQr["Image"] = file;
            return a
        })

    }

    const imageShowHandler = () => { // image Show handler
        let slides = []
        if (values.PaymentQr.Image[0] instanceof File) {
            slides = [{
                Image: URL.createObjectURL(values.PaymentQr.Image[0])
            }];
        } else {
            if (SystemSetting.Qr_Image === null) {
                customAlert({ Type: 3, Message: alertMessages.paymentORcodeIsRequired });
                slides = [];
            } else {
                slides = [{
                    Image: SystemSetting.Qr_Image
                }];
            }

        }
        setImageTable(slides)
    }

    function convertImageToFile(imageUrl) {
        const Party_Name = loginPartyName();
        return fetch(imageUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch image: ${response.status} ${response.statusText}`);
                }
                return response.blob();
            })
            .then(blob => {
                const filename = `${Party_Name}_PaymentQr.jpeg`;
                return new File([blob], filename);
            })
            .catch(error => {
                showToastAlert("QR Image Load Failed: " + error.message, "error");
                return null;
            });
    }
    function isFile(obj) {
        return obj instanceof File || (obj instanceof Blob && typeof obj.name === "string");
    }
    function isURL(str) {
        const urlPattern = new RegExp('^(ftp|http|https):\/\/[^ "]+$');
        return urlPattern.test(str);
    }



    useEffect(async () => {

        if (Object.keys(SystemSetting).length !== 0) {

            const file = await convertImageToFile(SystemSetting.Qr_Image)


            if (!isURL(SystemSetting.Qr_Image)) {
                setState((i) => {
                    const a = { ...i }
                    a.values.PaymentQr["Image"] = [null];
                    return a
                })
            } else {
                setState((i) => {
                    const a = { ...i }
                    if (isFile(file)) {
                        a.values.PaymentQr["Image"] = [file];
                    }
                    return a
                })
            }
        }
    }, [SystemSetting])



    const SaveHandler = async () => {
        const formData = new FormData(); // Create a new FormData object
        const BulkData = []

        try {

            Object.values(values).forEach(i => {
                if (!i?.id) return;
                if (i.SystemSetting === "HSN Code Digit") {
                    i.Value = i.Value.value
                }

                const arr = {
                    Setting: i.id,
                    Party: loginSelectedPartyID(),
                    Company: loginCompanyID(),
                    CreatedBy: loginUserID(),
                    Value: i.Value
                }
                BulkData.push(arr)

            })
            formData.append(`uploaded_images_${values.PaymentQr.id}`, values.PaymentQr.Image[0]); // Convert to JSON string
            formData.append('BulkData', JSON.stringify(BulkData)); // Convert to JSON string
            dispatch(savePartySetting({ formData }));

        } catch (e) { CommonConsole("SaveHandler :invoice configration", e) }
    };



    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop)
        removeBodyCss()
    }
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    const ToggleField = ({ label, checked, onChange, disabled, rightLabel }) => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 12px",
                    borderRadius: "10px",
                    marginBottom: "6px",
                    background: checked ? "#ede9fe" : "#f9fafb",
                    opacity: disabled ? 0.5 : 1,
                }}
            >
                {/* LEFT */}
                <span style={{ fontWeight: 500, color: "#111827" }}>
                    {label}
                </span>

                {/* RIGHT SIDE */}
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                    {/* 🔥 A4/A5 badge */}
                    {rightLabel && (
                        <div
                            style={{
                                display: "flex",
                                background: "#e5e7eb",
                                borderRadius: "999px",
                                padding: "2px",
                            }}
                        >
                            {/* A4 */}
                            <div
                                onClick={() => !disabled && onChange({ target: { checked: true } })}
                                style={{
                                    padding: "2px 10px",
                                    borderRadius: "999px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    background: checked ? "#5156be" : "transparent",
                                    color: checked ? "#fff" : "#374151",
                                }}
                            >
                                A4
                            </div>

                            {/* A5 */}
                            <div
                                onClick={() => !disabled && onChange({ target: { checked: false } })}
                                style={{
                                    padding: "2px 10px",
                                    borderRadius: "999px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    background: !checked ? "#5156be" : "transparent",
                                    color: !checked ? "#fff" : "#374151",
                                }}
                            >
                                A5
                            </div>
                        </div>
                    )}

                    {/* Toggle */}
                    {!rightLabel && (
                        <div
                            onClick={() => !disabled && onChange({ target: { checked: !checked } })}
                            style={{
                                width: "38px",
                                height: "22px",
                                borderRadius: "20px",
                                background: disabled
                                    ? (checked ? "#5156be" : "#d1d5db")   // 👈 key improvement
                                    : (checked ? "#5156be" : "#e5e7eb"),
                                position: "relative",
                                cursor: disabled ? "not-allowed" : "pointer",
                            }}
                        >
                            <div
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    background: "#fff",
                                    borderRadius: "50%",
                                    position: "absolute",
                                    top: "2px",
                                    left: checked ? "18px" : "2px",
                                    transition: "all 0.25s ease",
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const updateValue = (key, checked) => {
        setState((prev) => {
            const field = prev.values[key];

            if (!field) return prev; // safety

            return {
                ...prev,
                values: {
                    ...prev.values,
                    [key]: {
                        ...field, // ✅ preserve id, SystemSetting
                        Value: checked ? "1" : "0"
                    }
                }
            };
        });
    };

    const customSelectStyle = {
        control: (base, state) => ({
            ...base,
            borderRadius: "10px",
            borderColor: state.isFocused ? "#5156be" : "#e5e7eb",
            boxShadow: state.isFocused ? "0 0 0 2px rgba(124,58,237,0.2)" : "none",
            "&:hover": { borderColor: "#5156be" },
            minHeight: "36px"
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "10px",
            overflow: "hidden",
        }),
    };


    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <div className="page-content" style={{ background: "#f3f4f6", minHeight: "100vh" }}>
                    <Modal isOpen={modal_backdrop} style={{ width: "800px", height: "800px", borderRadius: "50%" }} className="modal-dialog-centered " toggle={() => { tog_backdrop() }}>
                        {(imageTable.length > 0) && <Slidewithcaption Images={imageTable} />}
                    </Modal>
                    <Container fluid>
                        <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>

                        <Card style={mainsectionCardStyle}>
                            <CardHeader className="card-header   text-black c_card_header" >
                                <h4 className="card-title text-black">{userPageAccessState.PageDescription}</h4>
                                <p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                            </CardHeader>

                            <CardBody className=" vh-10 0 text-black " >
                                <form noValidate>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px", alignItems: "start", zIndex: 0, position: "relative" }}>
                                        <Card className="mb-3" style={sectionCardStyle} onMouseEnter={cardHover} onMouseLeave={cardLeave}>
                                            <CardHeader style={CardHeaderStyle}>Payment QR</CardHeader>
                                            <CardBody style={{ padding: "14px" }}>

                                                {/* Hidden Input */}
                                                <input type="file" id="qrUpload" style={{ display: "none" }} onChange={onchangeHandler} />

                                                {/* 🔥 FULL CLICKABLE UPLOAD AREA */}
                                                <label htmlFor="qrUpload"
                                                    style={{
                                                        display: "block",
                                                        width: "100%",
                                                        border: "2px dashed #d1d5db",
                                                        borderRadius: "14px",
                                                        padding: "22px",
                                                        textAlign: "center",
                                                        background: "#f9fafb",
                                                        cursor: "pointer",
                                                        transition: "all 0.25s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.border = "2px dashed #5156be";
                                                        e.currentTarget.style.background = "#f5f3ff";
                                                        e.currentTarget.style.transform = "translateY(-1px)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.border = "2px dashed #d1d5db";
                                                        e.currentTarget.style.background = "#f9fafb";
                                                        e.currentTarget.style.transform = "translateY(0px)";
                                                    }}
                                                >

                                                    {/* TEXT */}
                                                    <div style={{ fontSize: "14px", fontWeight: 500, color: "#374151" }}>
                                                        Upload Payment QR
                                                    </div>

                                                    <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "2px" }}>
                                                        Click anywhere or drag & drop
                                                    </div>

                                                    {/* 🔥 IMAGE PREVIEW */}
                                                    {values.PaymentQr?.Image?.[0] && (
                                                        <div style={{ marginTop: "14px" }}>
                                                            <img
                                                                src={
                                                                    values.PaymentQr.Image[0] instanceof File
                                                                        ? URL.createObjectURL(values.PaymentQr.Image[0])
                                                                        : values.PaymentQr.Image[0]
                                                                }
                                                                alt="QR"
                                                                style={{
                                                                    width: "80px",
                                                                    height: "80px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "12px",
                                                                    border: "2px solid #ede9fe",
                                                                    boxShadow: "0 6px 16px rgba(124,58,237,0.15)",
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </label>

                                                {/* 🔥 ACTION BUTTONS */}
                                                {values.PaymentQr?.Image?.[0] && (
                                                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "16px", }}>
                                                        <button type="button" onClick={imageShowHandler} style={{ padding: "6px 12px", fontSize: "12px", borderRadius: "8px", border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", }}>
                                                            Preview
                                                        </button>

                                                        <button type="button" style={{ padding: "6px 12px", fontSize: "12px", borderRadius: "8px", border: "none", background: "#fee2e2", color: "#b91c1c", cursor: "pointer" }}
                                                            onClick={async () => {
                                                                const isConfirmed = await customAlert({
                                                                    Type: 7,
                                                                    Message: "Remove Payment QR?",
                                                                });

                                                                if (isConfirmed) {
                                                                    setState((i) => {
                                                                        const a = { ...i };
                                                                        a.values.PaymentQr["Image"] = [null];
                                                                        return a;
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                )}

                                            </CardBody>
                                        </Card>
                                        <Card className="mb-3" style={{ ...sectionCardStyle, position: "relative", zIndex: 5 }} onMouseEnter={cardHover} onMouseLeave={cardLeave}>
                                            <CardHeader style={CardHeaderStyle} >General Settings</CardHeader>
                                            <CardBody style={{ padding: "12px 14px" }}>

                                                <div className="mb-3">
                                                    <Label>{fieldLabel.HSNCodeDigit}</Label>
                                                    <Select value={values.HSNCodeDigit.Value} options={hsnDropOption} onChange={(evn) => onChangeSelecthandler(evn)} styles={customSelectStyle} menuShouldScrollIntoView={false} />
                                                </div>

                                            </CardBody>
                                        </Card>

                                        <Card className="mb-3" style={sectionCardStyle} onMouseEnter={cardHover} onMouseLeave={cardLeave}>
                                            <CardHeader style={CardHeaderStyle} >Print Configuration</CardHeader>
                                            <CardBody style={{ padding: "12px 14px" }}>

                                                <ToggleField
                                                    label={fieldLabel.Invoicea4}
                                                    rightLabel={values.Invoicea4.Value === "1" ? "A4" : "A5"}
                                                    checked={values.Invoicea4.Value === "1"}
                                                    onChange={(e) => updateValue("Invoicea4", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.ReturnA4Print}
                                                    rightLabel={values.ReturnA4Print.Value === "1" ? "A4" : "A5"}
                                                    checked={values.ReturnA4Print.Value === "1"}
                                                    onChange={(e) => updateValue("ReturnA4Print", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.CRDRNoteA4Print}
                                                    rightLabel={values.CRDRNoteA4Print.Value === "1" ? "A4" : "A5"}
                                                    checked={values.CRDRNoteA4Print.Value === "1"}
                                                    onChange={(e) => updateValue("CRDRNoteA4Print", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.OrderA4Print}
                                                    rightLabel={values.OrderA4Print.Value === "1" ? "A4" : "A5"}
                                                    checked={values.OrderA4Print.Value === "1"}
                                                    onChange={(e) => updateValue("OrderA4Print", e.target.checked)}
                                                />
                                            </CardBody>
                                        </Card>

                                        <Card className="mb-3" style={sectionCardStyle} onMouseEnter={cardHover} onMouseLeave={cardLeave}>
                                            <CardHeader style={CardHeaderStyle}>E-Invoice / E-Way</CardHeader>
                                            <CardBody style={{ padding: "12px 14px" }}>

                                                <ToggleField
                                                    label={fieldLabel.EInvoiceApplicable}
                                                    checked={values.EInvoiceApplicable?.Value === "1"}
                                                    onChange={(e) => updateValue("EInvoiceApplicable", e.target.checked)}
                                                    disabled={values.AutoEInvoice?.Value === "1"}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.AutoEInvoice}
                                                    checked={values.AutoEInvoice?.Value === "1"}
                                                    onChange={(e) => updateValue("AutoEInvoice", e.target.checked)}
                                                    disabled={values.EInvoiceApplicable?.Value !== "1"}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.EWayBillApplicable}
                                                    checked={values.EWayBillApplicable?.Value === "1"}
                                                    onChange={(e) => updateValue("EWayBillApplicable", e.target.checked)}
                                                    disabled={values.AutoEwayBill?.Value === "1"}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.AutoEwayBill}
                                                    checked={values.AutoEwayBill?.Value === "1"}
                                                    onChange={(e) => updateValue("AutoEwayBill", e.target.checked)}
                                                    disabled={values.EWayBillApplicable?.Value !== "1"}
                                                />

                                            </CardBody>
                                        </Card>

                                        <Card className="mb-3" style={sectionCardStyle} onMouseEnter={cardHover} onMouseLeave={cardLeave}>
                                            <CardHeader style={CardHeaderStyle}>Advanced</CardHeader>
                                            <CardBody style={{ padding: "12px 14px" }}>

                                                <ToggleField
                                                    label={fieldLabel.CreditDebitAmountRound}
                                                    checked={values.CreditDebitAmountRound?.Value === "1"}
                                                    onChange={(e) => updateValue("CreditDebitAmountRound", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.TCSAmountRound}
                                                    checked={values.TCSAmountRound?.Value === "1"}
                                                    onChange={(e) => updateValue("TCSAmountRound", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.InvoiceAmountRound}
                                                    checked={values.InvoiceAmountRound?.Value === "1"}
                                                    onChange={(e) => updateValue("InvoiceAmountRound", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.ShowBatch}
                                                    checked={values.ShowBatch?.Value === "1"}
                                                    onChange={(e) => updateValue("ShowBatch", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.ShowBatchNoOnGRNPrint}
                                                    checked={values.ShowBatchNoOnGRNPrint?.Value === "1"}
                                                    onChange={(e) => updateValue("ShowBatchNoOnGRNPrint", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.Showmixitem}
                                                    checked={values.Showmixitem?.Value === "1"}
                                                    onChange={(e) => updateValue("Showmixitem", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.ShowBatchNoOnChallanPrint}
                                                    checked={values.ShowBatchNoOnChallanPrint?.Value === "1"}
                                                    onChange={(e) => updateValue("ShowBatchNoOnChallanPrint", e.target.checked)}
                                                />

                                                <ToggleField
                                                    label={fieldLabel.ORDER_SPLIT_GST_NONGST}
                                                    checked={values.ORDER_SPLIT_GST_NONGST?.Value === "1"}
                                                    onChange={(e) => updateValue("ORDER_SPLIT_GST_NONGST", e.target.checked)}
                                                />

                                                {(IsSweetAndSnacks || isRACompany() || isFoodERPDotIn()) && (
                                                    <>
                                                        <ToggleField
                                                            label={fieldLabel.ShowChallanOnSalesOrder}
                                                            checked={values.ShowChallanOnSalesOrder?.Value === "1"}
                                                            onChange={(e) => updateValue("ShowChallanOnSalesOrder", e.target.checked)}
                                                        />

                                                        <ToggleField
                                                            label={fieldLabel.DatauploadtoTally}
                                                            checked={values.DatauploadtoTally?.Value === "1"}
                                                            onChange={(e) => updateValue("DatauploadtoTally", e.target.checked)}
                                                        />

                                                        <ToggleField
                                                            label={fieldLabel.AutoInvoiceSendToSap}
                                                            checked={values.AutoInvoiceSendToSap?.Value === "1"}
                                                            onChange={(e) => updateValue("AutoInvoiceSendToSap", e.target.checked)}
                                                        />
                                                    </>
                                                )}

                                            </CardBody>
                                        </Card>
                                        <div style={{ position: "fixed", bottom: "3px", left: "257px", zIndex: 1000 }}>
                                            <SaveButton
                                                loading={saveBtnloading}
                                                pageMode={pageMode}
                                                onClick={SaveHandler}
                                                userAcc={userPageAccessState}
                                                editCreatedBy={editCreatedBy}
                                                module={"GroupMaster"}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </CardBody>
                        </Card>
                    </Container >
                </div >
            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
};

export default InvoiceConfiguration

const cardHover = (e) => {
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.08)";
};

const cardLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0px)";
    e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.06)";
};

const mainsectionCardStyle = {
    borderRadius: "16px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
};

const sectionCardStyle = {
    borderRadius: "14px",
    border: "1px solid #e5e7eb",
    background: "#fafafa",   // 🔥 subtle grey
    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
    overflow: "visible"
};

const CardHeaderStyle = {
    fontWeight: 600,
    fontSize: "14px",
    padding: "8px 12px",
    background: "#eef2ff",
    color: "#4338ca",
    borderBottom: "1px solid #e5e7eb",
    borderLeft: "4px solid #5156be",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
}